/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import { Diagnostics } from '@tivocorp/tivo-webapp-loggers';

import { Locale } from '../../../../core/locale/Locale';
import { LocaleKeys } from '../../../../core/locale/LocaleKeys';
import { VuLogger } from '../../../../core/logging';
import { Log } from '../../../../core/logging/Log';
import { ScreenTaskControllerTypes } from '../../../../core/navigation/ScreenTaskControllerTypes';
import { AiringPreviewUtils } from '../../../../core/videoplayer/utils';
import { VideoPlaybackController } from '../../../../core/videoplayer/VideoPlaybackController';
import { OverlayTypes } from '../../../overlay/OverlayTypes';
import {
    hideOverlayDialog,
    showOverlayDialog,
} from '../../../overlaydialog/overlaydialog.reducers';
import { IOverlayDialog } from '../../../overlaydialog/overlaydialogprops';
import { setScreenTaskController } from '../../../screens/screens.reducers';
import { changeClosedCaptionLanguage } from '../../videoplayer.reducers';

const TAG = 'subtitleandcclanguageoverlay';
const GLOBAL_MOUSE_TRAP = 'SubtitleAndCCLanguageOverlay';

export const showSubtitleAndCCLanguageOverlay = () => (dispatch: Function, getState: Function) => {
    const subtitles = VideoPlaybackController.getInstance().getTextTracks();
    const { airingOffers, offerPreview, vodOfferPreview } = VideoPlaybackController.getInstance().getMetadata();
    const dataFormatter = new AiringPreviewUtils(airingOffers, offerPreview || vodOfferPreview);
    const audioSubtitlePopupTitle = dataFormatter.getSeasonEpisodeTitle();
    if (subtitles.length > 0) {
        const overlayDialogProps: IOverlayDialog = {
            hasDimmer: false,
            hasSeperator: false,
            options: subtitles,
            title: Locale.getString(LocaleKeys.SUBTITLE_OVERLAY_TITLE),
            subtitle: audioSubtitlePopupTitle,
            overlayType: OverlayTypes.SUBTITLE_AND_CC_LANGUAGE,
            mouseTrapValue: GLOBAL_MOUSE_TRAP,
        };

        dispatch(showOverlayDialog(overlayDialogProps));

        Diagnostics.debug(
            TAG,
            'showSubtitleAndCCLanguageOverlay {screenTaskController: ',
            ScreenTaskControllerTypes.SUBTITLE_AND_CC_LANGUAGE_OVERLAY,
            '}',
        );
        Log.d(
            TAG,
            'showSubtitleAndCCLanguageOverlay {screenTaskController: ',
            ScreenTaskControllerTypes.SUBTITLE_AND_CC_LANGUAGE_OVERLAY,
            '}',
        );
        dispatch(
            setScreenTaskController(ScreenTaskControllerTypes.SUBTITLE_AND_CC_LANGUAGE_OVERLAY),
        );
    }
};

export const onKeyBackSubtitleAndCCLanguageOverlay =
    (calledFromOnLanguageSelect?: boolean) => (dispatch: Function, getState: Function) => {
        const { isOverlayDialogActive } = getState().overlayDialog;

        if (isOverlayDialogActive) {
            dispatch(hideOverlayDialog());
        }

        Diagnostics.debug(
            TAG,
            'onKeyBackSubtitleAndCCLanguageOverlay {screenTaskController: ',
            ScreenTaskControllerTypes.DEFAULT_VIDEO_PLAYER_TASKS,
            '}',
        );
        Log.d(
            TAG,
            'onKeyBackSubtitleAndCCLanguageOverlay {screenTaskController: ',
            ScreenTaskControllerTypes.DEFAULT_VIDEO_PLAYER_TASKS,
            '}',
        );
        if (!calledFromOnLanguageSelect) {
            VuLogger.logUserActionEvent({
                actionName: VuLogger.UserActionEventActionName.SUBTITLE_AND_CC,
                action: VuLogger.UserActionEventAction.CANCEL,
                screen: VuLogger.UserActionEventScreen.OVERLAYS,
                selection: VideoPlaybackController.getInstance().getSelectedTextTrack(),
            });
        }
        dispatch(setScreenTaskController(ScreenTaskControllerTypes.DEFAULT_VIDEO_PLAYER_TASKS));
    };

export const onKeyOkSubtitleAndCCLanguageOverlay =
    () => (dispatch: Function, getState: Function) => {
        const { isOverlayDialogActive } = getState().overlayDialog;
        const { verticalPosition } = getState().overlayHighlight;
        const { value } = getState().inputFactory;

        // if value is equal to GLOBAL_MOUSE_TRAP then it means cursor is not on the overlay options
        if (value === GLOBAL_MOUSE_TRAP) {
            dispatch(onKeyBackSubtitleAndCCLanguageOverlay(true));
            return;
        }

        if (isOverlayDialogActive) {
            dispatch(onLanguageSelect(verticalPosition));
        }
    };

export const onLanguageSelect = (selectedIndex: number) => (dispatch: Function) => {
    dispatch(changeClosedCaptionLanguage(selectedIndex));
    dispatch(onKeyBackSubtitleAndCCLanguageOverlay(true));
};
